const getFiltroDesde = state => state.filtroDesde;
const getFiltroHasta = state => state.filtroHasta;
const getFiltroTipoDocumento = state => state.filtroTipoDocumento;
const getFiltroRuc = state => state.filtroRuc;
const getFiltroSerie = state => state.filtroSerie;
const getFiltroNumero = state => state.filtroNumero;
const getComprobantesEntity = state => state.comprobantesEntity;
const getFiltroDesdeGuia = state => state.filtroDesdeGuia;
const getFiltroHastaGuia = state => state.filtroHastaGuia;
const getFiltroSerieGuia = state => state.filtroSerieGuia;
const getFiltroEstado = state => state.filtroEstado;
const getFiltroTipoComprobanteGuia = state => state.filtroTipoComprobanteGuia;
export default {
  getFiltroDesde,
  getFiltroHasta,
  getFiltroTipoDocumento,
  getFiltroRuc,
  getFiltroSerie,
  getFiltroNumero,
  getComprobantesEntity,
  getFiltroDesdeGuia,
  getFiltroHastaGuia,
  getFiltroSerieGuia,
  getFiltroEstado,
  getFiltroTipoComprobanteGuia,
};



// WEBPACK FOOTER //
// ./src/store/modules/comprobantes/getters.js